<template>
  <div>
    <header-title
      title="المرجعيات القانونية"
      titlePrevious="الرئيسية "
      color="var(--primary)"
    />
    <div class="container pt-4">
      <b-row v-if="loading">
        <b-col cols="3">
          <b-skeleton height="250px" />
        </b-col>
        <b-col>
          <b-skeleton height="700px" />
        </b-col>
      </b-row>
      <b-alert v-else-if="hasError" variant="danger" :show="hasError">
        <h4 class="alert-heading">حدث خطأ أثناء جلب بيانات التشريع</h4>
        <div class="alert-body">
          لم يتم العثور على التشريع اللذي طلبته .
          <router-link class="alert-link cursor-pointer" to="/">
            عودة إلى الرئيسية
          </router-link>
        </div>
      </b-alert>
      <b-row v-else>
        <b-col cols="3">
          <b-card>
            <ul>
              <li class="d-flex align-items-center mb-1">
                <feather-icon size="17" icon="HashIcon" class="mr-50" />
                <span class="h5 mb-0">{{ regulation.regulation_no }}</span>
              </li>
              <li class="d-flex align-items-center mb-1">
                <feather-icon size="17" icon="CalendarIcon" class="mr-50" />
                <span class="h5 mb-0">{{ regulation.regulation_date }}</span>
              </li>
              <li class="d-flex align-items-center mb-1">
                <feather-icon size="17" icon="GridIcon" class="mr-50" />
                <span class="h5 mb-0">{{
                  regulation.regulationType.name_ar
                }}</span>
              </li>
              <li class="d-flex align-items-center">
                <feather-icon size="17" icon="FileIcon" class="mr-50" />
                <router-link
                  :to="{ name: 'file-view', query: { ep: regulation.file } }"
                  target="_blank"
                  class="h5 text-primary mb-0"
                  >تحميل الملف</router-link
                >
              </li>
            </ul>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <div v-html="regulation.content"></div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { mapActions, mapGetters } from "vuex";
import { BRow, BCard, BAlert, BCol, BSkeleton } from "bootstrap-vue";
import HeaderTitle from "@/modules/home/components/HeaderTitle.vue";
export default {
  props: {
    id: String,
  },
  components: {
    LoadingOverlay,
    BRow,
    BCard,
    BAlert,
    BCol,
    BSkeleton,
    HeaderTitle,
  },
  data() {
    return {
      hasError: false,
    };
  },
  methods: {
    ...mapActions("NgoHome/RegulationView", ["getRegulation"]),
  },
  computed: {
    ...mapGetters("NgoHome/RegulationView", ["regulation", "loading"]),
  },
  created() {
    this.getRegulation(this.id).catch(() => {
      this.hasError = true;
    });
  },
};
</script>
